import React from "react";

export default function TranscriptView({ transcript }) {
  if (!transcript || transcript.length === 0) {
    return <div style={s.empty}>No transcript available</div>;
  }

  return (
    <div style={s.wrap}>
      {transcript.map((entry, i) => {
        if (!entry.text) return null; // skip tool_call entries in server transcript
        const isSandy = entry.role === "sandy" || entry.role === "agent";
        const agentLabel = entry.agent && entry.agent !== "orchestrator" ? entry.agent : null;
        const ts = entry.timestamp || entry.time;
        return (
          <div key={i} style={{ ...s.row, justifyContent: isSandy ? "flex-start" : "flex-end" }}>
            <div style={{ ...s.bubble, ...(isSandy ? s.sandy : s.patient) }}>
              <div style={s.header}>
                <span style={isSandy ? s.labelSandy : s.labelPatient}>
                  {isSandy ? "Sandy" : "Patient"}
                  {agentLabel && <span style={s.agentTag}>{agentLabel}</span>}
                </span>
                {ts && (
                  <span style={s.time}>
                    {new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
                  </span>
                )}
              </div>
              <div style={s.text}>{entry.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const s = {
  wrap: { display: "flex", flexDirection: "column", gap: 6 },
  empty: { color: "#999", padding: 20, textAlign: "center", fontSize: 14 },
  row: { display: "flex" },
  bubble: {
    maxWidth: "80%", padding: "10px 14px", borderRadius: 10,
  },
  sandy: { background: "#f5f5f5", borderBottomLeftRadius: 2 },
  patient: { background: "#f0f7ff", borderBottomRightRadius: 2 },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4, gap: 12 },
  labelSandy: { fontSize: 11, fontWeight: 600, color: "#666", textTransform: "uppercase", letterSpacing: "0.03em" },
  labelPatient: { fontSize: 11, fontWeight: 600, color: "#3b82f6", textTransform: "uppercase", letterSpacing: "0.03em" },
  agentTag: { fontSize: 10, fontWeight: 500, color: "#999", marginLeft: 6, textTransform: "lowercase", letterSpacing: 0 },
  time: { fontSize: 11, color: "#bbb" },
  text: { fontSize: 14, lineHeight: 1.5, color: "#1a1a1a" },
};
